/* Importing the Navigate and useRoutes functions from the react-router-dom package. */
import { Navigate, useRoutes } from 'react-router-dom';

/* Importing the layout components. */
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import LogoTimeLayout from './layouts/LogoTimeLayout';

import WithoutAuthentication from './components/withoutAuthentication';
import WithAuthentication from './components/withAuthentication';

/* Importing the pages. */
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import MeetingCall from './pages/meeting/meeting.page.call';
import MeetingNew from './pages/meeting/meeting.page.new';
import ESteth from './pages/esteth/ESteth';
import PatientList from './pages/patient/Patient.page.list';
import PatientRegister from './pages/patient/Patient.page.register';
import PatientDetails from './pages/patient/Patient.page.details';
import DeviceList from './pages/device/Device.page.list';
import DeviceAdd from './pages/device/Device.page.add';
import DeviceDetails from './pages/device/Device.page.details';
import MonitoringList from './pages/monitor/monitor.page.list';
import MonitoringDashboard from './pages/monitor/monitor.page.dashboard';
import LocationList from './pages/location/Location.page.list';
import LocationAdd from './pages/location/Location.page.add';
import LocationDetails from './pages/location/Location.page.details';
import QuestionnaireList from './pages/questionnaire/Questionnaire.page.list';
import QuestionnaireResponseAdd from './pages/questionnaireResponse/QuestionnaireResponse.page.add';
import QuestionnaireResponseDetails from './pages/questionnaireResponse/QuestionnaireResponse.page.details';
import QuestionnaireResponseList from './pages/questionnaireResponse/QuestionnaireResponse.page.list';

/* Exporting the Router function. */
export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { path: '/', element: <Navigate to="/home" /> },

        { path: 'device/list', element: <WithAuthentication component={DeviceList} /> },
        { path: 'device/add', element: <WithAuthentication component={DeviceAdd} /> },
        { path: 'device/details/:id', element: <WithAuthentication component={DeviceDetails} /> },
        {
          path: 'device/edit/:id',
          element: <WithAuthentication component={(props) => <DeviceAdd {...props} isEdit />} />,
        },

        { path: 'esteth', element: <WithAuthentication component={ESteth} /> },

        { path: 'home', element: <WithAuthentication component={DashboardApp} /> },

        { path: 'meeting/new', element: <WithAuthentication component={MeetingNew} /> },

        { path: 'monitoring/list', element: <WithAuthentication component={MonitoringList} /> },

        { path: 'patient/list', element: <WithAuthentication component={PatientList} /> },
        { path: 'patient/register', element: <WithAuthentication component={PatientRegister} /> },
        { path: 'patient/details/:id', element: <WithAuthentication component={PatientDetails} /> },
        {
          path: 'patient/edit/:id',
          element: <WithAuthentication component={(props) => <PatientRegister {...props} isEdit />} />,
        },

        {
          path: 'covid19/dashboard',
          element: <WithAuthentication component={(props) => <DashboardApp {...props} isCovid19Page />} />,
        },
        {
          path: 'covid19/patientlist',
          element: <WithAuthentication component={(props) => <PatientList {...props} isCovid19Page />} />,
        },

        { path: 'location/list', element: <WithAuthentication component={LocationList} /> },
        { path: 'location/add', element: <WithAuthentication component={LocationAdd} /> },
        { path: 'location/details/:id', element: <WithAuthentication component={LocationDetails} /> },
        {
          path: 'location/edit/:id',
          element: <WithAuthentication component={(props) => <LocationAdd {...props} isEdit />} />,
        },
        { path: 'questionnaire/list', element: <WithAuthentication component={QuestionnaireList} /> },
        { path: 'questionnaireresponse/list/:id', element: <WithAuthentication component={QuestionnaireResponseList} /> },
        { path: 'questionnaireresponse/add/:id', element: <WithAuthentication component={QuestionnaireResponseAdd} /> },
        { path: 'questionnaireresponse/details/:id/:responseID', element: <WithAuthentication component={QuestionnaireResponseDetails} /> },
        {
          path: 'questionnaireresponse/edit/:id/:responseID',
          element: <WithAuthentication component={(props) => <QuestionnaireResponseAdd {...props} isEdit />} />,
        }
      ],
    },
    {
      path: '/',
      element: <LogoTimeLayout />,
      children: [{ path: 'monitoring/dashboard/:id', element: <MonitoringDashboard /> }],
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'meeting/call/:id', element: <WithAuthentication component={MeetingCall} /> },
        { path: 'login', element: <WithoutAuthentication component={Login} /> },
        { path: 'register', element: <WithoutAuthentication component={Register} /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },

        // { path: 'monitoring/dashboard/:id', element: <MonitoringDashboard /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
